import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers-pro";
import { useFormikContext, useField } from "formik";
import { getFieldId } from "./utilities";
import dayjs from "dayjs";
const DatePicker = (props) => {
    const { setFieldValue, setFieldTouched } = useFormikContext();
    const [field, meta] = useField(props.name);
    const fieldId = getFieldId(props.name);
    const { errors } = useFormikContext();
    const errorMessage = errors[props.name];
    return (_jsxs("div", { className: "form-group ", children: [_jsx("label", { htmlFor: fieldId, children: props.label }), _jsx("div", { className: "input-group", children: _jsx(MuiDatePicker, { value: (field.value && dayjs(field.value)) || null, onChange: (val) => {
                        setFieldValue(field.name, val?.toDate(), true);
                        setFieldTouched(field.name, true, false);
                    }, minDate: dayjs(props.minDate), maxDate: dayjs(props.maxDate ? props.maxDate : new Date("2099-12-31")), disabled: props.disabled, format: "DD-MM-YYYY", slotProps: {
                        textField: {
                            error: meta.touched && !!errorMessage,
                            helperText: meta.touched && errorMessage,
                            inputProps: {
                                sx: { height: "16px" },
                            },
                        },
                    } }) })] }));
};
export default DatePicker;
